import Main from './components/auth/default/Main'
const config = {
  loginUrl: '/auth',
  logoutUrl: '/logout',
  loginComponent: Main
}
export default config
